<template>
    <div class="branch_table_box">
        <el-input
            v-model="search"
            size="small"
            class="table_search"
            @keyup.native.enter="handleSearch(search)"
            @input="handleInput"
            :placeholder="$t('public.keyWord')"
            clearable>
        </el-input>
        <el-table
            :data="branch_list"
            class="branch_table"
            height="300"
            :default-sort="{prop: propAttr, order: order}"
            tooltip-effect="dark"
            @sort-change="handleTableSort"
            @selection-change="handleSelectionChange">
            <el-table-column
                type="selection"
                width="44">
            </el-table-column>
            <!-- 编号 -->
            <el-table-column
                :label="$t('message.cbranch.table1')"
                prop="branch_code"
                align="center"
                sortable="custom"
                show-overflow-tooltip>
            </el-table-column>
            <!-- 母公司 -->
            <el-table-column
                :label="$t('message.cbranch.table2')"
                prop="parentname"
                align="center"
                sortable="custom"
                show-overflow-tooltip>
            </el-table-column>
            <!-- 分行/子公司名称 -->
            <el-table-column
                :label="$t('message.cbranch.table3')"
                prop="branchname"
                align="center"
                sortable="custom"
                show-overflow-tooltip
                width='150'>
            </el-table-column>
            <!-- 联系电话 -->
            <el-table-column
                :label="$t('message.cbranch.table4')"
                prop="phone"
                align="center"
                sortable="custom"
                show-overflow-tooltip>
            </el-table-column>
            <!-- 电子邮箱 -->
            <el-table-column
                :label="$t('message.cbranch.table5')"
                prop="email"
                align="center"
                sortable="custom"
                show-overflow-tooltip>
            </el-table-column>
            <!-- 传真 -->
            <el-table-column
                :label="$t('message.cbranch.table6')"
                prop="fax"
                align="center"
                sortable="custom"
                show-overflow-tooltip>
            </el-table-column>
            <!-- 联络人 -->
            <el-table-column
                :label="$t('message.cbranch.table7')"
                prop="principal"
                align="center"
                sortable="custom"
                show-overflow-tooltip>
            </el-table-column>
			<!-- 可分配金額 -->
			<el-table-column
			    :label="$t('message.cbranch.table9')"
			    prop="amount"
			    align="center"
			    sortable="custom"
			    show-overflow-tooltip>
			</el-table-column>
            <!-- 操作 -->
            <el-table-column
                :label="$t('message.cbranch.table8')"
                align="center"
                width="150">
                <template v-slot="{row}">
                    <el-button
                        type="primary"
                        size="mini"
                        @click="handleModify(row.branch_id)">
                        <span>{{$t("public.modifyBtn")}}</span>
                    </el-button>
                    <el-button
                        type="danger"
                        size="mini"
                        @click="handleDel(row.branch_id)">
                        <span>{{$t("public.delBtn")}}</span>
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
		<!-- 分页器 -->
      <table-pagination
            :current-page="currentPage"
            :page-count="pageCount"
            :need-del="true"
            @current-change="handleCurrent"
            @handle-del="handleBatchDel">
        </table-pagination>
		<div style="padding: 10px; display: flex;justify-content: flex-end;">
			<el-pagination
			  @current-change="handleCurrent"
			  :current-page.sync="currentPage2"
			  :page-size="page.per_page"
			  layout="prev, pager, next, jumper"
			  :total="page.total"
			  background>
			</el-pagination>
		</div>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { tableSortHandle } from "@/utils/publicMethod.js";

export default {
	data() {
		return {
			currentPage2:0,
		}
	},
    mixins: [ tableSortHandle ],
    computed: mapState({
        branch_list: state => state.user.branch_list,
		page: state => state.user.page
    }),
	watch:{
		currentPage(){
			this.currentPage2 = this.currentPage
		}
	},
    methods: {
        ...mapActions([
            "handleDelBranch",
        ]),
        handleDel(id){ // 删除按钮
            this.$confirm(this.$t("message.cbranch.isDel"),{
                confirmButtonText: this.$t("public.confirmBtn"),
                cancelButtonText: this.$t("public.cancelBtn"),
                type: 'warning'
            }).then(() => this.handleDelBranch(id)
            ).then(res => {
                this.$emit('handleDelete', res)
            }).catch(() => {})
        }
    },
}
</script>

<style scoped>
.branch_table_box{
    background: #fff;
}
.table_search{
    width: 200px;
    margin: 10px;
}
</style>
